/** Default route after login and for authenticated guests (no PTT socket). */
export const DEFAULT_AUTH_HOME = "/users";
